import Cookies from 'js-cookie';

// Shared options for the non-sensitive `isLoggedIn` UI flag cookie (the
// actual auth token lives in localStorage, not a cookie - see
// utils/setAuth.js). `secure` is conditional on the page actually being
// served over HTTPS so it still works in local HTTP dev.
const isSecureContext = () =>
  typeof window !== 'undefined' && window.location.protocol === 'https:';

export const setIsLoggedInCookie = (value: boolean) => {
  Cookies.set('isLoggedIn', String(value), {
    expires: 365,
    secure: isSecureContext(),
    sameSite: 'strict'
  });
};

export const clearIsLoggedInCookie = () => {
  Cookies.remove('isLoggedIn');
};
